import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {SeatMapResponse} from 'app/types/service-types/AircraftTypes';
import {AircraftService} from 'app/services';

export const fetchSeatMap = (flightId: string) => async (dispatch: Dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await AircraftService.getSeatMap(flightId);
    dispatch(setSeatMap(response));
  } catch (err) {
    console.log(err);
    dispatch(setSeatMap(null));
  }
  dispatch(setLoading(false));
}

interface SeatMapSlice {
  seatMap: SeatMapResponse | null;
  loading: boolean;
}

const initialState: SeatMapSlice = {
  seatMap: null,
  loading: false
}

const stateSlice = createSlice({
  name: 'flights/seat-map',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload },
    setSeatMap: (state, action) => { state.seatMap = action.payload },
    clearSeatMap: (state) => { state.seatMap = null }
  }
});

export const {setLoading, setSeatMap, clearSeatMap} = stateSlice.actions;
export default stateSlice.reducer;
